export default {
  async get (data) {
    data['city_name'] = data["geo-city"]
    let date = data.date
    delete data["geo-city"]
    delete data["date"]
    let { condition_slug, city, temp, description, sunrise, sunset, wind_speedy, img_id, forecast } = await axios.post('chatbot/weather', data),
      txt = ''
    if (date) {
      date = date.split('T')[0].substring(5, 10).split('-').reverse().join('/')
      let d = forecast.filter(i => date === i.date)[0]
      condition_slug = d.condition
      txt = `<div>${city}</div>
        <div>${d.date} - ${d.weekday}</div>
        <div>${d.description}</div>
        <div>Max: ${d.max}º C | Min: ${d.min}º C </div>
        <div>Nascer do Sol: ${sunrise} - Pôr do Sol: ${sunset}</div>`
    } else {
      txt = `<img height="100" src="https://assets.hgbrasil.com/weather/images/${img_id}.png" />
      <div>${city} ${temp}º C</div>
      <div>${description}</div>
      <div>Nascer do Sol: ${sunrise} - Pôr do Sol: ${sunset}</div>
      <div>Velocidade do vento: ${wind_speedy}</div>
      <h3 class="mt-3 mb-2">Previsão para os próximos dias:</h3>
      <table><tbody>`
      forecast.filter(d => {
        txt += `<tr>
<td class="px-2 pb-1 align-middle">${d.date} - ${d.weekday}</td>
<td class="px-2 pb-1 align-middle text-center">${d.description}</td>
<td class="px-2 pb-1 align-middle">Max: ${d.max}º C e Min: ${d.min}º C </td>
</tr>`
      })
      txt + `</tbody></table>`
    }
    return `<div class="weather ${condition_slug} pa-10">${txt}</div>`
  }
};
